<nx-headline-box 
    [label]="label" 
    class="mt-[1.25rem] border-b border-[#E0E0E0]">
</nx-headline-box>
<nx-default-box class="bg-white border-b border-gray"
    [label]="'Summe'">
    {{sum | secondsToDuration}}
</nx-default-box>